import { readonly, ref } from 'vue';
import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';

export function useEmployeeSearch() {
  const employees = ref([]);
  const pagination = ref({ total: 0, page: 1, page_size: 100 });
  const loading = ref(false);
  const error = ref(null);

  const searchEmployees = async payload => {
    loading.value = true;
    error.value = null;
    try {
      const response = await axiosClient.post(API_ENDPOINTS.searchEmployees, payload);
      if (!Array.isArray(response.data?.items)) {
        throw new Error('Invalid employee search response.');
      }
      employees.value = response.data.items.map(employee => ({
        ...employee,
        employee_company_name: employee.company?.company_name || '',
      }));
      pagination.value = {
        total: Number(response.data.total) || 0,
        page: Number(response.data.page) || 1,
        page_size: Number(response.data.page_size) || payload.page_size,
      };
      return true;
    } catch (requestError) {
      error.value = requestError.response?.data?.error
        || requestError.message
        || 'Failed to search employees.';
      return false;
    } finally {
      loading.value = false;
    }
  };

  return {
    employees: readonly(employees),
    pagination: readonly(pagination),
    loading: readonly(loading),
    error: readonly(error),
    searchEmployees,
  };
}
